import Page from '~/enums/page'
import helpers from '~/helpers'
import EcommerceApiService from '~/services/ecommerce-api-service'
import { useAuthStore } from '~/store/auth'
import { useCartStore } from '~/store/cart'
import type { CartProductData, EcommerceCartItem } from '~/types/cart'
import type { CloudPaymentsWidgetData } from '~/types/orders'

export function usePaymentWidget () {
  const authStore = useAuthStore()
  const cartStore = useCartStore()

  function initCloudPaymentsWidget (cloudPaymentsWidgetData: CloudPaymentsWidgetData, orderId: string): void {
    const { language, options, paymentType } = cloudPaymentsWidgetData
    const cloudPaymentsWidget = new (window as any).cp.CloudPayments(
      { language: language ?? 'ru-RU', sbpSupport: false }
    );
    cloudPaymentsWidget.pay(
      paymentType ?? 'charge',
      options ?? {},
      {
        onComplete: function (paymentResult: any, options: any): void {
          console.log('onComplete', paymentResult, options)
        },
        onFail: function (reason: any, options: any): void {
          console.error('onFail', reason, options)
        },
        onSuccess: async function (options: any): void {
          console.log('onSuccess', options)

          trackOrder(orderId);

          await navigateTo(authStore.isUser ? Page.AccountOrders : Page.Main)
        }
      }
    )
  }

  function trackOrder (orderId: string): void {
    const ecommerceCartItems = cartStore.cartProductsData.map(
      (x: CartProductData): EcommerceCartItem => {
        const { attributes, id, meta } = x
        const { name } = attributes
        const { brandName, categoryNames, quantity } = meta
        const discountedPrice = helpers.getProductDiscountedPrice(x) ?? 0
        const ecommerceCartItem: EcommerceCartItem = { item_id: id, item_name: name, price: discountedPrice, quantity }

        if (typeof brandName === 'string') {
          ecommerceCartItem.item_brand = brandName
        }

        if (categoryNames && Array.isArray(categoryNames)) {
          ecommerceCartItem.item_category = [...categoryNames].sort()
        }

        return ecommerceCartItem
      }
    )
    const shippingCost = helpers.convertKopecksToRubles(cartStore.finalShippingCostInKopecks ?? 0)!
    const total = helpers.convertKopecksToRubles(cartStore.totalInKopecks)!

    EcommerceApiService.purchase(ecommerceCartItems, orderId, total, shippingCost, cartStore.form.promoCodeName)
  }

  return { initCloudPaymentsWidget, trackOrder }
}
